module.exports = __webpack_public_path__ + "img/mainFunction-icon2.8a2c84eb.png";